<template>
    <div class="en_add">
        <el-card>
            <el-form ref="form" :model="form" :rules="rule" label-width="100px" :inline="false" size="normal">
                <el-form-item label="优惠券名称" prop="name">
                    <el-col :span="8">
                        <el-input v-model="form.name" show-word-limit />
                    </el-col>
                </el-form-item>
                <el-form-item label="类型">
                    <el-radio-group v-model="form.type" @change="typeChange">
                        <!-- <el-radio :label="0">通用</el-radio> -->
                        <el-radio :label="1">活动</el-radio>
                        <el-radio :label="2">VIP会员</el-radio>
                        <el-radio :label="4">道具券</el-radio>
                    </el-radio-group>
                </el-form-item>
                <template v-if="form.type == 2">
                    <el-form-item label="有效期类型">
                        <el-radio-group v-model="form.timeType" :disabled="!!id">
                            <el-radio :label="0">固定时间区间</el-radio>
                            <el-radio :label="1">领取后有效</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item v-if="form.timeType == 0" label="有效期" prop="bonus">
                        <el-date-picker
                            v-model="form.time"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            format="yyyy-MM-dd HH:mm:ss"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                        >
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item v-if="form.timeType == 1" label="有效时长">
                        <el-input size="small" style="width:100px" v-model="form.timeTypeValue" />
                        <el-radio-group v-model="form.timeUnit" style="margin-left:16px">
                            <el-radio :label="0">天</el-radio>
                            <el-radio :label="1">小时</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="是否膨胀">
                        <el-radio-group v-model="form.isExpansion" :disabled="!!id">
                            <el-radio :label="0">否</el-radio>
                            <el-radio :label="1">是</el-radio>
                        </el-radio-group>
                        <span v-if="form.isExpansion == 1" style="color:#fda400;margin-left:16px">该功能只在pc端的会员中心生效</span>
                    </el-form-item>
                    <el-form-item v-if="form.isExpansion == 1" label="膨胀比例">
                        <el-input size="small" style="width:100px" v-model="expansionMin" />
                        <span style="margin:0 8px">至</span>
                        <el-input size="small" style="width:100px" v-model="expansionMax" />
                        <span style="margin-left:8px">%</span>
                        <div style="color:#fda400;line-height:30px">填写膨胀区间比例，如 5% 至 10%</div>
                    </el-form-item>
                </template>
                <el-form-item v-if="form.type != 2" label="有效期" prop="bonus">
                    <el-date-picker
                        v-model="form.time"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        format="yyyy-MM-dd HH:mm:ss"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                    >
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="优惠券数量" prop="number">
                    <el-col :span="8">
                        <el-input-number v-model="form.number" :step="1"></el-input-number>
                    </el-col>
                </el-form-item>
                <el-form-item label="优惠方式" prop="discountType">
                    <el-radio-group v-model="form.discountType" :disabled="form.type == 2 || form.type == 4">
                        <el-radio :label="0">折扣减免</el-radio>
                        <el-radio :label="1">定额减免</el-radio>
                    </el-radio-group>
                    <div style="height:10px"></div>
                    原价减
                    <el-select style="width:100px" v-if="form.type == 2 || form.type == 4" size="small" v-model="form.discountValue">
                        <el-option :value="55" label="55"> </el-option>
                        <el-option :value="40" label="40"> </el-option>
                        <el-option :value="20" label="20"> </el-option>
                      <el-option :value="15" label="15"> </el-option>
                      <el-option :value="10" label="10"> </el-option>
                    </el-select>
                    <el-input v-else size="small" v-model="form.discountValue" style="width:100px"></el-input>
                    {{ form.discountType == 0 ? "%" : "元" }}
                </el-form-item>
                <el-form-item label="使用限制">
                    <el-input size="small" style="width:100px" v-model="form.limit"></el-input>
                    每人可以领取多少张
                    <br />
                    <div class="warning" style="color:#fda400;line-height:30px">
                        若不限次数，请填0
                    </div>
                </el-form-item>
                <template v-if="form.type == 1">
                    <el-form-item label="选择活动">
                        <el-col :span="8">
                            <fuzzy-selection
                                ref="fuzzySelection"
                                :value.sync="form.activityId"
                                :type="4"
                                clearable
                                tipName="活动"
                            />
                        </el-col>
                    </el-form-item>
                    <el-form-item label="适用票种" prop="scopeTypes">
                        <el-checkbox-group v-model="form.scopeTypes">
                            <!-- <el-checkbox label="-1">全部</el-checkbox> -->
                            <el-checkbox :label="item.id + ''" v-for="(item, index) in tickList" :key="index">{{
                                item.name
                            }}</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item label="票种类型" prop="ticketType">
                        <el-radio-group v-model="form.ticketType">
                            <el-radio :label="0">单人票</el-radio>
                            <el-radio :label="1">团体票</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="小程序" prop="miniprogramType">
                        <el-radio-group v-model="form.miniprogramType">
                            <!-- <el-checkbox label="-1">全部</el-checkbox> -->
                            <el-radio
                                :label="item.id"
                                v-for="(item, index) in [
                                    { id: 0, name: '扬帆小程序' },

                                ]"
                                :key="index"
                                >
<!--                              { id: 1, name: 'PAGC小程序' },-->
                              {{ item.name }}</el-radio
                            >
                        </el-radio-group>
                    </el-form-item>
                </template>
                <template v-if="form.type == 4">
                    <el-form-item label="道具类型" prop="scopeTypes">
                        <el-select
                            v-model="form.scopeTypes"
                            multiple
                            placeholder="请选择道具类型"
                            style="width: 300px"
                        >
                            <el-option
                                v-for="item in cooProTypeList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                            />
                        </el-select>
                    </el-form-item>
                </template>
                <el-form-item label="描述">
                    <el-col :span="8">
                        <el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="form.desc"> </el-input>
                    </el-col>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="medium" @click="onSubmit">{{ id ? "修改" : "提交" }}</el-button>
                </el-form-item>
            </el-form>
        </el-card>
    </div>
</template>

<script>
import imgup from "@/components/upImg/index.vue";
import rules from "@/utils/rules";
import fuzzySelection from "@/components/fuzzySelection";
export default {
    components: {
        imgup,
        fuzzySelection,
    },
    data() {
        return {
            id: null,
            form: {
                name: "",
                discountType: "",
                scopeTypes: [],
                time: [],
                beginTime: "",
                endTime: "",
                number: "",
                limit: "0",
                discountValue: "",
                desc: "",
                activityId: "",
                bonus: "",
                type: 1,
                miniprogramType: 0,
                ticketType: 0,
                timeType: 0,
                timeTypeValue: "",
                timeUnit: 0,
                isExpansion: 0,
            },
            expansionMin: 5,
            expansionMax: 10,
            rule: rules.reqAll({
                name: "请输入优惠券名称",
                scopeTypes: "请选择适用类型",
                logo: "请输入企业logo",
                city: "请输入省份和城市",
                people: "请输入公司人事",
                financing: "请输入融资情况",
                type: "请输入类型",
                business: "请输入行业",
                serverArea: "请输入业务区域",
                companyDesc: "请输入企业介绍",
                intro: "请输入企业简介",
            }),
            action: {
                action: "bonus",
            },
            province: {},
            city: {},
            baseurl: this.$store.state.env.cdnImg,
            yu: "/" + this.$store.state.env.domain,
            cardList: [],
            tickList: [],
            cooProTypeList: [],
            first: true,
        };
    },
    watch: {
        "form.activityId"(newValue, oldValue) {
            this.findTick();
            if (this.first) {
                return;
            }
            this.form.scopeTypes = [];
        },
        // "form.type"(val) {
        //     if (val == 2) {
        //         this.form.discountValue = 20;
        //         this.form.discountType = 0;
        //     }
        // },
    },
    computed: {},
    created() {
        sessionStorage.setItem("action", "bonus");
        this.getCooProType();
        this.getform();
        // this.getEnv()
    },
    methods: {
        change(val) {
            this.form.desc = val;
        },
        typeChange() {
            if (this.form.type == 2 || this.form.type == 4) {
                this.form.discountValue = 20;
                this.form.discountType = 0;
            }
            this.form.scopeTypes = [];
            this.form.timeType = 0;
        },
        async getCooProType() {
            const { data: res } = await this.$http.get("/admin/User/getConfig");
            if (res.errorCode == 200) {
                this.cooProTypeList = res.data.cooProType || [];
            }
        },
        async findTick() {
            var { data: res } = await this.$http.get(
                `/admin/Activity/getTicketList?activityId=${this.form.activityId}&page=1&pageSize=5000`
            );

            //   console.log(res)
            this.tickList = res.data.list;
            this.first = false;
        },
        validateVipFields() {
            if (this.form.type != 2) {
                return true;
            }
            if (this.form.timeType == 0) {
                if (!this.form.time || !this.form.time[0] || !this.form.time[1]) {
                    this.$message.error("请选择固定时间区间");
                    return false;
                }
            }
            if (this.form.timeType == 1) {
                const value = Number(this.form.timeTypeValue);
                if (this.form.timeTypeValue === "" || Number.isNaN(value) || value <= 0) {
                    this.$message.error("请填写领取后有效时长");
                    return false;
                }
            }
            if (this.form.isExpansion == 1) {
                const min = Number(this.expansionMin);
                const max = Number(this.expansionMax);
                if (this.expansionMin === "" || this.expansionMax === "" || Number.isNaN(min) || Number.isNaN(max)) {
                    this.$message.error("请填写膨胀区间比例");
                    return false;
                }
                if (min > max) {
                    this.$message.error("膨胀比例最小值不能大于最大值");
                    return false;
                }
            }
            return true;
        },
        toHourValue(value, unit) {
            const num = Number(value);
            return Number(unit) === 0 ? num * 24 : num;
        },
        buildExpansionRatio() {
            if (this.form.type != 2 || this.form.isExpansion != 1) {
                return "";
            }
            return [Number(this.expansionMin), Number(this.expansionMax)];
        },
        parseExpansionRatio(val) {
            if (val == null || val === "") {
                this.expansionMin = 5;
                this.expansionMax = 10;
                return;
            }
            let arr = val;
            if (typeof val === "string") {
                try {
                    arr = JSON.parse(val);
                } catch (e) {
                    arr = val.replace(/[\[\]]/g, "").split(",");
                }
            }
            if (Array.isArray(arr)) {
                this.expansionMin = arr[0] != null ? arr[0] : "";
                this.expansionMax = arr[1] != null ? arr[1] : "";
            }
        },
        async onSubmit() {
            if (!this.validateVipFields()) {
                return;
            }
            var url;
            if (this.id) {
                url = "/admin/Coupon/edit";
            } else {
                url = "/admin/Coupon/add";
            }
            const useAfterClaim = this.form.type == 2 && this.form.timeType == 1;
            const payload = {
                ...this.form,
                id: this.id,
                scopeTypes: this.form.scopeTypes.toString(),
                beginTime: useAfterClaim ? "" : this.form.time[0],
                endTime: useAfterClaim ? "" : this.form.time[1],
            };
            if (this.form.type == 2) {
                payload.timeType = this.form.timeType;
                payload.timeTypeValue =
                    this.form.timeType == 1 ? this.toHourValue(this.form.timeTypeValue, this.form.timeUnit) : 0;
                payload.isExpansion = this.form.isExpansion;
                payload.expansionRatio = this.buildExpansionRatio();
            } else {
                delete payload.timeType;
                delete payload.timeTypeValue;
                delete payload.isExpansion;
            }
            delete payload.timeUnit;

            var { data: res } = await this.$http.post(url, payload);
            if (res.errorCode == 200) {
                this.$message.success(res.message);
                this.$router.push("/coupon_list");
            }
        },
        async getform() {
            if (!this.$route.query.id) {
                return;
            }
            this.id = this.$route.query.id;
            const { data: res } = await this.$http.get("/admin/Coupon/getById?id=" + this.id);
            if (res.errorCode == 200) {
                // console.log(res);
                // console.log(res.data);
                const scopeTypesStr = res.data.scopeTypes || res.data.ticketIds || "";
                const toNum = (val, fallback) =>
                    val != null && val !== "" && !Number.isNaN(Number(val)) ? Number(val) : fallback;
                this.form = {
                    ...res.data,
                    time: [res.data.beginTime, res.data.endTime],
                    scopeTypes: scopeTypesStr ? scopeTypesStr.split(",") : [],
                    timeType: toNum(res.data.timeType, 0),
                    timeTypeValue:
                        res.data.timeTypeValue != null && res.data.timeTypeValue !== ""
                            ? res.data.timeTypeValue
                            : "",
                    timeUnit: 1,
                    isExpansion: toNum(res.data.isExpansion, 0),
                };
                this.parseExpansionRatio(res.data.expansionRatio);

                this.$nextTick(() => {
                    if (!this.$refs.fuzzySelection) {
                        return;
                    }
                    this.$refs.fuzzySelection.options = [{ id: this.form.activityId, title: this.form.activityName }];
                    this.$refs.fuzzySelection.val = this.form.activityId;
                });
            }
            //  this.form.initViews =
        },
        // async getEnv() {
        //   var { data } = await this.$http.get('/admin/UserCard/getList')
        //   //   console.log(data);
        //   this.cardList = data.data.list
        // },
    },
};
</script>

<style lang="less">
.en_add {
    .box {
        display: inline-block;
        width: 300px;
        input {
            border-color: #dcdfe6 !important;
        }
    }
}
</style>
